/**
 * Row resolution for a grid's selection-bar actions.
 *
 * Infinite-scroll grids key selection on positional grid ids, so a bulk
 * action resolves each id to its real row through the MUI apiRef at click
 * time. This module owns that resolution and the active/deactivated
 * partition every bulk bar needs — under select-all the lists come back
 * empty, since the action targets the filtered set server-side instead.
 *
 * Contains:
 * - resolveSelectionRows — (selection, apiRef) → { selectAll, rows,
 *   activeRows, deactivatedRows }
 * - SELECTION_ACTION_SX — the selection bar's action-button sx
 *
 * Returns plain JS — no JSX.
 */

/** Action-button styling inside the dark selection bar. */
export const SELECTION_ACTION_SX = { color: 'inherit', textTransform: 'none', fontWeight: 600 };

/**
 * @param {{ ids: Array, selectAll: boolean }} selection - EntityGrid's
 *   selection callback payload.
 * @param {object} apiRef - The grid's MUI apiRef (third callback argument).
 * @returns {{ selectAll: boolean, rows: object[], activeRows: object[],
 *   deactivatedRows: object[] }} Resolved rows, empty under select-all.
 */
export function resolveSelectionRows(selection, apiRef) {
  const { ids, selectAll } = selection;
  const rows = selectAll ? [] : ids.map(id => apiRef.current?.getRow?.(id)).filter(Boolean);
  return {
    selectAll,
    rows,
    activeRows: rows.filter(row => !row.deactivated),
    deactivatedRows: rows.filter(row => row.deactivated),
  };
}
